"use strict";

exports.__esModule = true;
exports.isDef = isDef;
function isDef(val) {
  return val !== undefined && val !== null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kyligence-ui/lib/utils/shared.js
// module id = 382
// module chunks = 0